export const useGlobalStore = defineStore('global', () => {
  const fetchInitialPending = ref(false)
  const boxDetailsDrawer = ref(false)
  const boxDetailsDrawerScrollId = ref<string | null>(null)
  const mobileSearch = ref(false)
  const searchTerm = ref('')
  const boxSearchTerm = ref('')
  const lastSearchTerm = ref<string | null>(null)
  const isSearchbarExpanded = ref(false)

  function setBoxDetailsDrawer(show: boolean) {
    boxDetailsDrawer.value = show
  }

  function openBoxDetailsDrawer() {
    boxDetailsDrawer.value = true
  }

  function setBoxSearchTerm(payload: string) {
    boxSearchTerm.value = payload
  }

  function setIsSearchbarExpanded(isExpanded: boolean) {
    isSearchbarExpanded.value = isExpanded
  }

  return {
    // state
    fetchInitialPending,
    boxDetailsDrawer,
    boxDetailsDrawerScrollId,
    mobileSearch,
    searchTerm,
    boxSearchTerm,
    lastSearchTerm,
    isSearchbarExpanded,
    // actions
    setBoxDetailsDrawer,
    openBoxDetailsDrawer,
    setBoxSearchTerm,
    setIsSearchbarExpanded,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useGlobalStore, import.meta.hot))
}
